export class InvalidPaymentIdError extends Error {
  constructor(paymentId: unknown) {
    super(`Cannot build payment request: payment_id is not a valid integer (received: ${JSON.stringify(paymentId)})`);
    this.name = 'InvalidPaymentIdError';
  }
}
